import $ from "jquery";

$(function () {
  const topBannerMdlNotificationApp = document.getElementById("top-banner-mdl-notification-app");
  const topBannerMdlNotificationAppButton = $("#top-banner-mdl-notification-app-button");

  if (topBannerMdlNotificationApp) {
    $(topBannerMdlNotificationAppButton).on("click", function () {
      $("#top-banner-mdl-notification-app").addClass("active");
      $("body").addClass("overlay-open");
    });
  }
})
